import React from 'react'

class BlockLazy extends React.Component {
    constructor(props) {
        super(props)
        this.blockRef = React.createRef()
        this.observer = null
        this.timeoutId = null
        this.state = {
            isInViewPort: false,
        }
    }
    componentDidMount() {
        this.observer = new IntersectionObserver(this.handleIntersection, {
            rootMargin: '100px',
            threshold: 0.5,
        })
        this.timeoutId = setTimeout(() => {
            const blockElement = this.blockRef.current
            if (blockElement && this.observer) {
                this.observer.observe(blockElement)
            }
        }, 1000)
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }
    }

    handleIntersection = (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.setState({ isInViewPort: true })
                clearTimeout(this.timeoutId)
                if (this.observer && this.blockRef.current) {
                    this.observer.unobserve(this.blockRef.current)
                }
            }
        })
    }
    render() {
        return (
            <div ref={this.blockRef} {...this.props} className="onScrollHandle">
                {this.state.isInViewPort ? this.props.children : null}
            </div>
        )
    }
}

export default BlockLazy
